import React, { useRef } from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import RokuRemoteConfig from "../components/RokuRemoteApp/RokuRemoteConfig";
import RokuRemoteMobileConfig from "../components/RokuRemoteApp/RokuRemoteMobileConfig";
import NotificationAlert from "react-notification-alert";
import RokuRemoteAppChart from "components/RokuRemoteApp/RokuRemoteAppChart";
import RokuRemoteAppUserTable from "components/RokuRemoteApp/RokuRemoteAppUserTable";

export default function RokuRemoteApp() {
  document.title = "Roku Remote App - TMH Admin";
  const notificationAlertRef = useRef(null);

  const notify = (place, message, type = 1, autoDismiss = 5) => {
    let options = {
      place: place,
      message: <div>{message}</div>,
      type: type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: autoDismiss,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  return (
    <>
      <div className="content">
        <div div className="react-notification-alert-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <h3 className="title">ROKU REMOTE</h3>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="12">
                    <RokuRemoteMobileConfig notify={notify} />
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <RokuRemoteConfig notify={notify} />
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <RokuRemoteAppChart />
                  </Col>
                  <Col md="12">
                    <RokuRemoteAppUserTable />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}
